export function getValueOrDefault(value: any, defaultValue: any = "--") {
  if (value === "" || value === undefined || value === null) {
    return defaultValue;
  }
  if (typeof value === "object") {
    return value?.label || value?.value || defaultValue;
  }
  return value;
}

export function capitalizeArray(arr: any, type?: any) {
  return type === "create"
    ? arr.map(
      (item: any) => item?.label?.charAt(0).toUpperCase() + item?.label.slice(1)
    )
    : arr.map((item: any) => item?.charAt(0).toUpperCase() + item?.slice(1));
}
